import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

import { onMounted, ref } from "vue";

import { Loading } from "@element-plus/icons-vue";

import AbitSelect from "@/components/global/form/AbitSelect.vue";
import ApiService from "@/core/services/ApiService";


export default /*#__PURE__*/_defineComponent({
  __name: 'AbitAccommodationTypes',
  props: {
    name: {},
    label: {},
    placeholder: {},
    horizontal: { type: [String, Boolean] },
    required: { type: Boolean },
    wrapperClass: {}
  },
  setup(__props: any) {

const accommodationTypes = ref([]);

const loading = ref<boolean>(true);

const props = __props;

onMounted(() => {
    //Load city list
    ApiService.get("/accommodation-types")
        .then(({ data }) => {
            accommodationTypes.value = data.content.accommodationTypes;
        })
        .catch()
        .finally(() => (loading.value = false));
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createBlock(AbitSelect, _mergeProps(props, {
    options: accommodationTypes.value,
    clearable: ""
  }), {
    prefix: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            class: "is-loading"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Loading))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["options"]))
}
}

})